import { Avatar, Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

export const MultiSelectedItemStyled = styled(Box).attrs({
  pr: { sm: '300' },
  mr: { sm: '300' },
  my: { sm: '300' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[800]};
  `};
`;
